// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yrmcn{width:100%;display:flex !important;flex-direction:column;background-color:#fff;border-radius:8px}.SdEz8{width:100% !important;box-sizing:border-box;height:52px;padding:0 16px;cursor:pointer}.Xvelf{display:inline-flex !important;align-items:center}.U7BXT{width:100%;box-sizing:border-box;padding:0 16px 16px 16px;flex-direction:column}.Y_Uxr{width:100%;flex-direction:column}.M1pNY{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileCard": `yrmcn`,
	"mobileHeader": `SdEz8`,
	"chevron": `Xvelf`,
	"mobileBody": `U7BXT`,
	"body": `Y_Uxr`,
	"desktopCard": `M1pNY`
};
export default ___CSS_LOADER_EXPORT___;
